import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "m-tokendetail" }
const _hoisted_2 = { class: "page-head flex-between" }
const _hoisted_3 = { class: "token-tx-record" }
const _hoisted_4 = { class: "bottom-page" }

import PageContainer from "@/components/mobile/PageContainer.vue";
import TokenInfos from "./TokenInfos.vue";
import TokenTxTable from "./TokenTxTable.vue";
import useTokenDetail from "@/mixins/useTokenDetail";


export default /*@__PURE__*/_defineComponent({
  __name: 'TokenDetail',
  setup(__props) {

const {
  searchAddress,
  propsAdr,
  tokenName,
  TokenInfo,
  detailLoading,
  txLoading,
  pages,
  Trades,
  searchAdr,
  pageChange,
  sizeChange,
  clearAddrFilter,
} = useTokenDetail();

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: "/token",
        class: "back light"
      }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode("Token 列表")
        ])),
        _: 1
      })
    ]),
    _createVNode(TokenInfos, {
      infos: _unref(TokenInfo),
      loading: _unref(detailLoading)
    }, null, 8, ["infos", "loading"]),
    _createElementVNode("div", _hoisted_3, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "head" }, [
        _createElementVNode("span", { class: "tab-title" }, "交易记录")
      ], -1)),
      _createVNode(TokenTxTable, {
        addr: _unref(propsAdr),
        token: _unref(tokenName),
        trades: _unref(Trades),
        loading: _unref(txLoading),
        pages: _unref(pages),
        onClear: _unref(clearAddrFilter)
      }, null, 8, ["addr", "token", "trades", "loading", "pages", "onClear"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(PageContainer, {
        onPageChange: _unref(pageChange),
        onSizeChange: _unref(sizeChange),
        currentPage: _unref(pages).currentPage,
        pageSize: _unref(pages).pageSize,
        total: _unref(pages).total,
        simple: false
      }, null, 8, ["onPageChange", "onSizeChange", "currentPage", "pageSize", "total"])
    ])
  ]))
}
}

})